<ng-container *transloco="let t; prefix: 'group-management.change-group-size'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" (ngSubmit)="confirm()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            @if (changeType() === 'addCount') {
              <p>{{ t('add-count-desc', addCountDescriptionParams()) }}</p>
            }
            @if (changeType() === 'remove') {
              <p>{{ t('remove-desc', countDescriptionParams()) }}</p>
            }

            @if (showSpaceSelect()) {
              <div>
                <label class="mb-1 block text-sm font-medium text-primary-text" for="spaces-to-add">
                  {{ t('add-count-label') }}
                </label>
                <select
                  id="spaces-to-add"
                  class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm text-primary-text"
                  [ngModel]="spacesToAdd()"
                  (ngModelChange)="spacesToAdd.set($event); onSpacesToAddChange()"
                  name="spacesToAdd"
                >
                  @for (option of spaceOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <p>{{ t('add-desc', countDescriptionParams()) }}</p>
            }

            <p>{{ t('billing-notice') }}</p>
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button
          type="button"
          class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
          (click)="cancel()"
          [disabled]="submitting()"
        >
          {{ t('cancel') }}
        </button>
        <button
          type="submit"
          class="rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
          [disabled]="submitting()"
        >
          {{ t('confirm') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
